import { trackEvent } from '@centered/analytics'
import Image from 'next/image'
import { useRef } from 'react'
import GoogleAuthCta from '../shared/GoogleAuthCta'
import Wrapper from '../shared/Wrapper'
import AppPreviewImage from './assets/App-preview-sp.png'
import AuthPageImage from './assets/auth_page.png'
import { useIsMobile } from '@centered/components/dist/hooks/useIsMobile'

export default function HeroSection(): JSX.Element {
  return (
    <Wrapper
      style={{
        minHeight: '15vh',
      }}
    >
      <div className="hero flex flex-col mb-6 md:flex-row md:items-center">
        <div className="md:w-1/2 flex-shrink-0">
          <h1>
            {/* <div
              className="font-bold text-3xl text-v2-gray-lighter mb-4"
              style={{
                textDecoration: 'line-through',
              }}
            >
              Procrastination. Stress.
            </div> */}

            <div className="text-4xl font-bold mb-8 md:mr-8 leading-snug">
              Feel great at 3pm.
            </div>
          </h1>

          <p className="text-2xl md:mr-8 leading-normal mb-6">
            Like you, we want to get off work earlier and feel happier.
            <br />
            <br />
            So we made a website with flow music, timers, phone blocking & more.
            <br />
            <br />
            We bet you’ll finish your work happier & in half the time.
            <br />
          </p>
          <GoogleAuthCta
            source={'v3CTA1Google'}
            noGoogleAccountSource={'v3CTA1nonGoogle'}
          />
          <p className="text-xl leading-normal md:mr-8 mb-8 mt-10">
            <i>Claim your 14-Day Free Trial - no credit card required.</i>
          </p>
        </div>

        <AppPreview />
      </div>
    </Wrapper>
  )
}

export function AppPreview(): JSX.Element {
  return (
    <>
      <style jsx>{`
        .preview-image {
          width: 550px !important;
          aspect-ratio: 1.034;
        }

        @media (min-width: 768px) {
          .preview-image {
            width: 800px !important;
          }
        }
      `}</style>

      <div className="w-1/2 overflow-hidden flex-shrink-0 preview-image relative transform -translate-x-10 md:translate-x-0">
        <Image
          src={AppPreviewImage}
          alt="App Preview"
          width={800}
          height={774}
          priority
          className="object-contain object-center"
        />
      </div>
    </>
  )
}

export function SigninHero(): JSX.Element {
  const isMobile = useIsMobile()

  return (
    <>
      <style jsx>{`
        .preview-image {
          width: 550px !important;
          aspect-ratio: 800 / 800;
        }

        @media (min-width: 768px) {
          .preview-image {
            width: 800px !important;
          }
        }
      `}</style>

      <div
        className={`'w-1/2 overflow-hidden flex-shrink-0 preview-image relative transform -translate-x-10 md:translate-x-0 cursor-pointer'${
          isMobile ? ' pt-4 px-6' : ''
        }`}
      >
        <Image
          src={AuthPageImage}
          alt="Sukha"
          width={isMobile ? 350 : 800}
          height={isMobile ? 350 : 800}
          priority
          className="object-contain object-center"
        />
      </div>
    </>
  )
}
